import styles from "./styles.module.css";

export default function Toggle({ toggle }) {
  return (
    <div className={styles.toggle}>
      <div
        className={
          toggle.value === "api"
            ? `${styles.toggleButton} ${styles.active}`
            : styles.toggleButton
        }
        onClick={() => toggle.set("api")}
      >
        APIs
      </div>
      <div
        className={
          toggle.value === "webhook"
            ? `${styles.toggleButton} ${styles.active}`
            : styles.toggleButton
        }
        onClick={() => toggle.set("webhook")}
      >
        WEBHOOKS
      </div>
    </div>
  );
}
